import Joi from "joi";
import MembershipTypes from "@/types/marketing/MembershipTypes";
import MembershipInterests from "@/types/marketing/MembershipInterests";

const enquireSchema = Joi.object({
  membership_type: Joi.string()
    .valid(...MembershipTypes)
    .required(),
  first_name: Joi.string().min(1).required(),
  last_name: Joi.string().min(1).required(),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
  job_title: Joi.string().max(30).required(),
  job_company: Joi.string().max(30).required(),
  membership_interest: Joi.string()
    .valid(...MembershipInterests)
    .required(),
  other_membership_interest: Joi.string().when("membership_interest", {
    is: "Other",
    then: Joi.string().required(),
    otherwise: Joi.string().allow(null, ""),
  }),
  marketing_emails: Joi.boolean(),
  query_params: Joi.object().optional().allow(null),
});

export default enquireSchema;
